import $ from 'jquery';
import BaseEvent from './base-event';

export default class FooterEvents extends BaseEvent {
    constructor() {
        super({
            event_id: '3',
            category: 'footer',
            action: 'click',
        });

        this.$footerCont = $('.main-footer');

        this.init();
    }

    init() {
        this.onFooterSecondaryMenu();
        this.onFooterSocials();
    }

    onFooterSecondaryMenu() {
        this.$footerCont.find('.secondary-nav-list').find('a').on('click', (e) => {
            this.fireEvent({
                label: this.toNormalizedString(e.currentTarget.innerText),
                destination_url: e.currentTarget.href,
            });
        });
    }

    onFooterSocials() {
        this.$footerCont.find('.primary-nav-list').find('a, button').on('click', (e) => {
            this.fireEvent({
                label: this.toNormalizedString(e.currentTarget.title),
                destination_url: e.currentTarget.href,
            });
        });
    }
}
